import { render, staticRenderFns } from "./TestPopupModal.vue?vue&type=template&id=211dfcbf&scoped=true&"
import script from "./TestPopupModal.vue?vue&type=script&lang=js&"
export * from "./TestPopupModal.vue?vue&type=script&lang=js&"
import style0 from "./TestPopupModal.vue?vue&type=style&index=0&id=211dfcbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211dfcbf",
  null
  
)

export default component.exports